import { render, staticRenderFns } from "./CourierInternalNotes.vue?vue&type=template&id=2d4a4f7b&scoped=true"
import script from "./CourierInternalNotes.vue?vue&type=script&lang=js"
export * from "./CourierInternalNotes.vue?vue&type=script&lang=js"
import style0 from "./CourierInternalNotes.vue?vue&type=style&index=0&id=2d4a4f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a4f7b",
  null
  
)

export default component.exports